
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Press() {
  const articles = [
    {
      publication: "Digital Journal",
      headline: "Saudi-Born Venture Capitalist Yazan Al Homsi's Recycling Technology Investment Gains Corporate Backing",
      url: "https://www.digitaljournal.com/pr/news/binary-news-network/saudi-born-venture-capitalist-yazan-al-1573468875.html",
      excerpt: "Yazan Al Homsi's strategic investment in Aduro Clean Technologies receives validation through major corporate partnerships.",
      date: "2024"
    },
    {
      publication: "Westmount Mag",
      headline: "Yazan Al Homsi Champions Sustainable Energy Through Strategic Investment in Charbone Hydrogen",
      url: "https://www.westmountmag.ca/yazan-al-homsi-champions-sustainable-energy-through-strategic-investment-in-charbone-hydrogen-corporation/",
      excerpt: "Exploring how Yazan Al Homsi's investment strategy focuses on sustainable energy solutions and green hydrogen technology.",
      date: "2024"
    },
    {
      publication: "Global Banking & Finance",
      headline: "Yazan Al Homsi: Investing in Aduro Clean Technologies' AI-Powered Waste Management Breakthroughs",
      url: "https://www.globalbankingandfinance.com/yazan-al-homsi-investing-in-aduro-clean-technologies-ai-powered-waste-management-breakthroughs/",
      excerpt: "Analysis of Yazan Al Homsi's investment approach to AI-powered waste management and recycling technologies.",
      date: "2024"
    },
    {
      publication: "Net News Ledger",
      headline: "Shell and TotalEnergies Partnerships Signal Corporate Validation of Yazan Al Homsi's Strategy",
      url: "https://www.netnewsledger.com/2025/07/28/shell-and-totalenergies-partnerships-signal-corporate-validation-of-yazan-al-homsis-recycling-investment-strategy/",
      excerpt: "Major energy companies' partnerships validate Yazan Al Homsi's investment thesis in recycling technology.",
      date: "2024"
    },
    {
      publication: "The Boss Magazine",
      headline: "Yazan Al Homsi on How AI is Driving ESG and Business Transformation in 2024",
      url: "https://thebossmagazine.com/post/yazan-al-homsi-ai-esg-transformation-2024/",
      excerpt: "Insights from Yazan Al Homsi on the intersection of artificial intelligence and ESG investment strategies.",
      date: "2024"
    },
    {
      publication: "MTL Times",
      headline: "Vancouver Investor Yazan Al Homsi Reveals Why Chemical Recycling Represents Prime Market Opportunity",
      url: "https://mtltimes.ca/business/vancouver-investor-yazan-al-homsi-reveals-why-chemical-recycling-represents-prime-market-opportunity/",
      excerpt: "Yazan Al Homsi discusses the market potential and investment opportunities in chemical recycling technology.",
      date: "2024"
    },
    {
      publication: "The Boss Magazine",
      headline: "Yazan Al Homsi on Small-Cap Investing",
      url: "https://thebossmagazine.com/post/yazan-al-homsi-small-cap-investing/",
      excerpt: "Strategic insights into small-cap investment approaches and market opportunities from Yazan Al Homsi.",
      date: "2024"
    },
    {
      publication: "London Loves Business",
      headline: "Yazan Al Homsi and Aduro Clean Technologies: Pioneering Sustainable Energy Investment",
      url: "https://londonlovesbusiness.com/yazan-al-homsi-and-aduro-clean-technologies-pioneering-sustainable-energy-investment-in-vancouver/",
      excerpt: "Exploring the partnership between Yazan Al Homsi and Aduro Clean Technologies in sustainable energy innovation.",
      date: "2024"
    }
  ];

  const topics = [
    "ESG Investment",
    "Small-Cap VC",
    "Clean Tech",
    "AI & Waste Management",
    "Chemical Recycling",
    "Green Hydrogen"
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      
      {/* Hero Section */}
      <section className="bg-slate-900 text-white py-16">
        <div className="container mx-auto px-6">
          <h1 className="text-5xl font-bold mb-6">Yazan Al Homsi in the Media</h1>
          <p className="text-xl text-gray-300 max-w-3xl">
            Yazan Al Homsi's insights on ESG investment, clean technology, and venture capital 
            featured in leading publications worldwide.
          </p>
        </div>
      </section>

      {/* Topics */}
      <section className="py-12 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-2xl font-bold text-slate-900 mb-8 text-center">Coverage Topics</h2>
          <div className="flex flex-wrap justify-center gap-4">
            {topics.map((topic, index) => (
              <span 
                key={index}
                className="bg-emerald-100 text-emerald-800 px-4 py-2 rounded-full text-sm font-medium"
              >
                {topic}
              </span>
            ))}
          </div>
        </div>
      </section>

      {/* Featured Articles */}
      <section className="py-20">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-bold text-slate-900 text-center mb-16">Featured Articles</h2>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <div className="p-6">
                  <div className="flex items-center mb-4">
                    <div className="w-10 h-10 bg-emerald-500 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-newspaper-line text-white"></i>
                    </div>
                    <div>
                      <span className="text-sm font-medium text-emerald-600">{article.publication}</span>
                      <div className="text-xs text-gray-500">{article.date}</div>
                    </div>
                  </div>
                  
                  <h3 className="text-lg font-bold text-slate-900 mb-3 leading-tight">
                    {article.headline}
                  </h3>
                  
                  <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                    {article.excerpt}
                  </p>
                  
                  <a 
                    href={article.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-emerald-500 hover:bg-emerald-600 text-white font-medium py-2 px-4 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
                  >
                    Read Article
                    <i className="ri-external-link-line ml-2"></i>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Media Kit */}
      <section className="py-20 bg-slate-100">
        <div className="container mx-auto px-6">
          <div className="bg-white rounded-lg shadow-lg p-8 text-center">
            <h2 className="text-3xl font-bold text-slate-900 mb-6">Media Inquiries</h2>
            <p className="text-xl text-gray-600 mb-8 max-w-2xl mx-auto">
              For interviews, expert commentary, or media kit requests, please contact Yazan Al Homsi directly.
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <a 
                href="/contact" 
                className="bg-emerald-500 hover:bg-emerald-600 text-white font-bold py-3 px-6 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                Contact for Media
              </a>
              <a 
                href="https://ae.linkedin.com/in/yazanhomsi" 
                target="_blank"
                rel="noopener noreferrer"
                className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                LinkedIn Profile
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
